export default __webpack_public_path__ + "fonts/2e4e2e71640e6ccb86d217a415bba684.eot";